<template>
  <SelectPickerMultiple
    v-slot="{ item, selected, active }"
    v-model="selected"
    api-value="/api/currencies/search?query="
    :placeholder-value="placeholderValue"
    :label="label"
  >
    <span
      class="block truncate"
      :class="{ 'font-medium': selected, 'font-normal': !selected }"
    >
      <img
        :src="item.image"
        alt=""
        class="flex-shrink-0 rounded-sm h-4 w-6 mr-3"
      >
    </span>

    <span
      class="block truncate mr-3 font-medium "
      :class="{ 'font-gray-900': selected, 'font-normal': !selected }"
    >
      {{ item.id }}
    </span>

    <span
      class="block truncate mr-3 "
      :class="{ 'font-medium': selected, 'font-light': !selected }"
    >
      {{ item.name }}
    </span>

    <span
      v-if="selected"
      class="absolute inset-y-0 left-0 flex items-center pl-3"
      :class="{ 'text-font': active, 'text-primary': !active }"
    >
      <CheckIcon
        class="h-5 w-5"
        aria-hidden="true"
        :class="{ 'text-white': active, 'text-primary': !active }"
      />
    </span>
  </SelectPickerMultiple>
</template>

<script setup>
import { ref, watch } from 'vue';
import { CheckIcon } from '@heroicons/vue/24/solid';
import SelectPickerMultiple from '@/ComponentsDeprecated/Select/SelectPickerMultiple';

const props = defineProps({
  modelValue: {
    type: Array,
    required: false,
    default: [],
  },
  placeholderValue: {
    type: String,
    required: false,
    default: 'Select Languages',
  },
  label: {
    type: String,
    required: false,
    default: 'Select Languages',
  },
});

const emit = defineEmits({ update: (_value) => true });
const selected = ref(props.modelValue);

watch(selected, () => {
  emit('update:modelValue', selected.value);
});

</script>
